import { useEffect, useState } from "react";


const CanvaFrame = (props) => {


    const [fullVideo, setFullVideo] = useState(false)


    useEffect(() => {
        if(props.url.includes('canva')){
            props.setNext(true);
        }else{
            props.setNext(true);
        }

    }, []);
    return(
        <>
        <div className={fullVideo ? "full-width-video" : "iframeDiv"}>
            <iframe 
                className={fullVideo ? "full-width-video" : "canvaFrame cursadasIFrame"}
                loading="lazy"  
                src={props.url} 
                allow="fullscreen">
            </iframe>
            <button className={fullVideo ? "green-btn setpointer full-width-btn" : "white-btn setpointer"} onClick={() => setFullVideo(!fullVideo)}>{fullVideo ? "Contraer" : "Expandir"}</button>
        </div>
        </>
    );
}

export default CanvaFrame;